import DuoGarageGridItemDesktop from '@/components/atoms/images/duoGridItemDesktop'
import Faded from '@/components/templates/animated/faded'
import Link from 'next/link'
import * as React from 'react'
import { ICar, ICarObj, IGalleryImage } from 'shared-interfaces'
import styled from 'styled-components'

const GridContainer = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    grid-gap: 5px;
    background-color: white;
    width: 100%;
    height: 100%;
`

interface Props {
    cars_ids_list: string[]
    carsData: ICarObj
    get_cover_img: (car: ICar) => IGalleryImage | undefined
    garage_link_id: string
}

class GarageDuoGrid extends React.Component<Props, {}> {
    componentDidMount() {}

    render() {
        let { get_cover_img, carsData, cars_ids_list, garage_link_id } =
            this.props
        return (
            <GridContainer>
                {cars_ids_list.length > 0 &&
                    cars_ids_list.map((id, index) => {
                        let car = carsData[id]

                        if (car) {
                            return (
                                <Link
                                    href={`/garage/${garage_link_id}/car/${car.id}/overview`}
                                    key={index}
                                >
                                    <a
                                        data-attr={`garage_grid_item_desktop_${id}`}
                                    >
                                        <Faded>
                                            <DuoGarageGridItemDesktop
                                                carInfoAndCoverImageObj={{
                                                    car: car,
                                                    cover_image:
                                                        get_cover_img(car),
                                                }}
                                            />
                                        </Faded>
                                    </a>
                                </Link>
                            )
                        }
                    })}
            </GridContainer>
        )
    }
}

export default GarageDuoGrid
